<div *ngIf="visible" [ngClass]="stylesClass"
  class="{{stylesClass}} bg-white w-full flex flex-col gap-2 items-center justify-center h-60">
  <img class="inline-block min-w-[5rem] w-20 h-20 object-cover object-center"
    src="assets/icons/transaction/empty-data.svg" alt="No data" />
  <span class="text-gray-400 text-sm">
    {{'COMMON.NO_DATA' | translate}}
  </span>
</div>